import { ProfileInfo } from '@/features/profile/ProfileInfo'
import { Page, Text } from '@/ui-kit'
import { Trans } from '@lingui/react/macro'

const ProfilePage = () => {
  return (
    <Page>
      <Text type="h4" className="py-8">
        <Trans>Profile</Trans>
      </Text>
      <ProfileInfo />
    </Page>
  )
}

export default ProfilePage
